<template>
  <div class="experts-page">
  <PageTitle :title="t('experts')" />


    <StateWrapper
      :content="experts"
      :loadingStatus="loadingStatus"
      :checkLogin="false"
    >
      <div class="wrapper">


        <ExpertCard
        v-for="v in experts"
        :key="v.id"
        :expert="v"
        />

        <div class="flex flex__jc-c">

           <vue-awesome-paginate
           :total-items="data.usersCount"
           v-model="currentPage"
           :items-per-page="itemsPerPage"
           :max-pages-shown="maxPagesShown"
           @click=getExperts()
          />
        </div>
      </div>
    </StateWrapper>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { customAxios } from "@/service/customAxios";
import { t } from "@/utils/translate";

import ExpertCard from "@/components/ExpertCard.vue";
import StateWrapper from "@/components/StateWrapper.vue";
import PageTitle from "@/elements/PageTitle.vue";

export default {
  components: { ExpertCard, StateWrapper, PageTitle },
  setup() {
    const experts = ref([]);
    const currentPage = ref(1);
    const maxPagesShown = ref(5);
    const itemsPerPage = ref(10);
    const loadingStatus = ref("loading");
    const data = ref();

    async function getExperts() {
         try {
          const r = await customAxios.post("person/experts/paginated",{
            page: currentPage.value,
            notePerPage: itemsPerPage.value,
          });
              if (r.status === 200) {
                  experts.value = r.data.persons;
              data.value = r.data;
              }
              loadingStatus.value = "loaded";

        } catch (e) {
          loadingStatus.value = "error";
          console.log(e);
        }
      }


    onMounted(async () => {
      await getExperts();
    });

    return {
      loadingStatus,
      experts,
      data,
      getExperts,
      t,
      itemsPerPage,
      currentPage,
      maxPagesShown,
    };
  },
};
</script>

<style lang="scss">
 .experts-page {
    position: relative;

    .wrapper {
      @include page;
    }

    &__links {
      margin-top: 40px;
    }

    &__link {
      position: relative;
      border-radius: 8px;
      background-color: rgba($text, 0.1);
      text-decoration: none;
      color: $text;
      display: block;
      padding: 32px 16px;
      box-sizing: border-box;

      h4,
      p {
        margin-bottom: 40px;
      }
    }

    .article-page__methods {
      p {
        margin: 0 0 16px 0;
        padding-left: 8px;
        font-weight: 700;
      }

      ul {
        display: flex;
        flex-wrap: wrap;
      }

      li {
        @include flex-center;
        background-color: $accent-1;
        color: #fff;
        display: inline-block;
        vertical-align: baseline;
        padding: 8px;
        border-radius: 8px;
        margin: 8px;
      }
    }

    &__link + .article-page__link {
      margin-top: 30px;
    }
  }
</style>













